export default __webpack_public_path__ + "static/media/10.8f2a5e34.jpg";